import { useCallback, useState } from "react";

export const useModalState = (): {
  show: boolean;
  onHide: () => void;
  onShow: () => void;
  setShow: (show: boolean) => void;
} => {
  const [show, setShow] = useState(false);

  const onHide = useCallback(() => {
    setShow(false);
  }, [setShow]);

  const onShow = useCallback(() => {
    setShow(true);
  }, [setShow]);

  return { show, onHide, onShow, setShow };
};

export type ModalProps = {
  show: boolean;
  onHide: () => void;
};
